import { render, staticRenderFns } from "./TestChat.vue?vue&type=template&id=53b262b5&"
import script from "./TestChat.vue?vue&type=script&lang=js&"
export * from "./TestChat.vue?vue&type=script&lang=js&"
import style0 from "./TestChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports